export default "__VITE_ASSET__BHUnQt1m__"